<template>
  <div>
    <contract-close-list></contract-close-list>
    <administrator-action></administrator-action>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import ContractCloseList from './Components/ContractCloseList'
import AdministratorAction from './Components/AdministratorAction'

export default {
  components: {
    ContractCloseList,
    AdministratorAction
  },
  async created () {
    const vm = this
    vm.pms ('SystemAdministrator', 'visible', 'r')
  }
};
</script>

<style >
</style>
